export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";